export const NOT_ACTIVE = 0;
export const ACTIVE = 1;
export const VERIFIED = 2;
export const PENDING = 3;
export const REJECTED = 4;
